/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum TypeOfSample {
  Serum = 'Serum',

  Urine = 'Urine',

  Semen = 'Semen',

  Blood = 'Blood',

  Stool = 'Stool',

  Sputum = 'Sputum',

  SlitSkin = 'Slit Skin',

  Tissue = 'Tissue',

  Pus = 'Pus',

  Vaginal = 'Vaginal',

  AF = 'Ascitic Fluid',

  BF = 'Body Fluid',

  CSF = 'Cerebrospinal fluid',

  KJF = 'Knee Joint Fluid',

  PF = 'Pleural Fluid',
}
